import { BaseRouteService } from "./BaseRouteService";

export class CablePuzzleService extends BaseRouteService {
    /**
     * Stuurt de puzzel-oplossing naar de backend ter validatie
     *
     * @param selections De gemaakte verbindingen (kleur → poort)
     * @returns true als correct, anders false
     */
    public async submitPuzzleSolution(selections: Record<string, string>): Promise<boolean> {
        const response: {
            success: boolean;
        } = await this.postJsonApi<{ success: boolean }, { selections: Record<string, string> }>(
            "game/cable/solve",
            { selections }
        );
        return response.success;
    }

    public async shouldShowPuzzle(): Promise<boolean> {
        const response: {
            show: boolean;
        } = await this.getJsonApi<{ show: boolean }>("game/cable/show");
        return response.show;
    }

    public async triggerPuzzle(): Promise<boolean> {
        const response: {
            success: boolean;
        } = await this.postJsonApi<{ success: boolean }>("game/cable/trigger", {});
        return response.success;
    }
}
